import { faCheckCircle, faExclamationTriangle, faQuestionCircle, faExclamationCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Button } from 'react-bootstrap'
import "./AlertModal.css"

function AlertModal({ title, description, alertType, button, isShow }) {
    var typeBadge = { icon: faQuestionCircle, color: 'gray' }

    switch(alertType){
        case("SUCCESS"):
            typeBadge = { icon: faCheckCircle, color: 'green' }
            break
        case("WARNING"):
            typeBadge = { icon: faExclamationTriangle, color: 'orange' }
            break
        case("EXTREME"):
            typeBadge = { icon: faExclamationCircle, color: 'red' }
            break
        case("ERROR"):
            typeBadge = { icon: faTimesCircle, color: 'red' }
            break
    }

    return (
        <div 
        className='alert-modal'
        style={{ display: isShow ? 'block': 'none' }}
        >
            <div className='alert-modal-window alert-modal-content'>
                <div style={{ display: 'flex', marginBottom: 23 }}>
                    <div className='icon'>
                        <FontAwesomeIcon icon={typeBadge.icon} color={typeBadge.color}/>
                    </div>
                    <div> 
                        <div className='title'>{title}</div>
                        <div className='desc'>{description}</div>
                    </div>
                </div>
                <hr/>
                <div className='button-container'>
                    { button.map((item, key) =>
                    <Button
                    key={key}
                    variant={item.variant}
                    size="sm"
                    onClick={()=>{
                        item.onClick()
                    }}>
                        {item.title}
                    </Button>   
                    )}
                </div>
            </div>
            
        </div>
    )
}

export default AlertModal
